

















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class BalanceTable extends Vue {
  @Prop() readonly balance!: any;

  rows: any = [
    { text: Vue.prototype.$t('Tillgångar'), values: [], styles: ['section-title'] },
    {
      text: Vue.prototype.$t('Tecknat men ej inbetalt kapital'),
      values: ['A', 'L'],
      styles: [''],
    },
    { text: Vue.prototype.$t('Anläggningstillgångar'), values: [], styles: ['section-title'] },
    {
      text: Vue.prototype.$t('Immateriella anläggningstillgångar'),
      values: ['B', 'L'],
      styles: ['sub-item'],
    },
    {
      text: Vue.prototype.$t('Materiella anläggningstillgångar'),
      values: ['C', 'L'],
      styles: ['sub-item'],
    },
    {
      text: Vue.prototype.$t('Finansiella anläggningstillgångar'),
      values: ['D', 'L'],
      styles: ['sub-item'],
    },
    {
      text: Vue.prototype.$t('Summa anläggningstillgångar'),
      values: ['E', 'L'],
      styles: ['major_sum'],
    },
    { text: Vue.prototype.$t('Omsättningstillgångar'), values: [], styles: ['section-title'] },
    { text: Vue.prototype.$t('Varulager m.m.'), values: ['F', 'L'], styles: ['sub-item'] },
    { text: Vue.prototype.$t('Kundfordringar'), values: ['G', 'L'], styles: ['sub-item'] },
    {
      text: Vue.prototype.$t('Övriga kortfristiga fordringar'),
      values: ['H', 'L'],
      styles: ['sub-item'],
    },
    {
      text: Vue.prototype.$t('Kortfristiga placeringar'),
      values: ['I', 'L'],
      styles: ['sub-item'],
    },
    { text: Vue.prototype.$t('Kassa och bank'), values: ['J', 'L'], styles: ['sub-item'] },
    {
      text: Vue.prototype.$t('Summa omsättningstillgångar'),
      values: ['K', 'L'],
      styles: ['major_sum'],
    },
    {
      text: Vue.prototype.$t('Summa tillgångar'),
      values: ['L', 'L'],
      styles: ['major_major_sum'],
    },
    { text: Vue.prototype.$t('Eget kapital och skulder'), values: [], styles: ['section-title'] },
    { text: Vue.prototype.$t('Eget kapital'), values: ['M', 'S'], styles: [''] },
    { text: Vue.prototype.$t('Obeskattade reserver'), values: ['N', 'S'], styles: [''] },
    { text: Vue.prototype.$t('Avsättningar'), values: ['O', 'S'], styles: [''] },
    { text: Vue.prototype.$t('Skulder'), values: [], styles: ['section-title'] },
    { text: Vue.prototype.$t('Långfristiga skulder'), values: ['P', 'S'], styles: ['sub-item'] },
    { text: Vue.prototype.$t('Kortfristiga skulder'), values: ['Q', 'S'], styles: ['sub-item'] },
    { text: Vue.prototype.$t('Summa skulder'), values: ['R', 'S'], styles: ['major_sum'] },
    {
      text: Vue.prototype.$t('Summa eget kapital och skulder'),
      values: ['S', 'S'],
      styles: ['major_major_sum'],
    },
  ];
  cols: any = [];
  hoveredCol: number = -1;
  hoveredRow: number = -1;

  getColsClass() {
    return 'cols' + this.cols.length;
  }

  getHovered(col: number, row: number) {
    if (col === this.hoveredCol && row === this.hoveredRow) {
      return 'hovered-exact';
    } else if (col === this.hoveredCol || row === this.hoveredRow) {
      return 'hovered';
    }
    return '';
  }

  mouseOver(col: number, row: number) {
    this.hoveredCol = col;
    this.hoveredRow = row;
  }

  mouseOut() {
    this.hoveredCol = -1;
    this.hoveredRow = -1;
  }

  val(i: number, row: any) {
    const name = row.values[0];
    if (name === undefined) {
      return '';
    }
    return this.balance.sheets[i][name];
  }

  part(i: number, row: any) {
    const name1 = row.values[0];
    const name2 = row.values[1];
    if (name1 === undefined || name2 === undefined) {
      return '';
    }
    const n1 = Number(this.balance.sheets[i][name1]);
    const n2 = Number(this.balance.sheets[i][name2]);
    if (n2 === 0) {
      return 0;
    }
    return n1 / n2;
  }

  title(i: number) {
    return (
      this.balance.sheets[i].DATE_TO.substr(0, 7) +
      ' (' +
      this.balance.sheets[i].MONTHS + ' ' +
      Vue.prototype.$t('mån') + ')'
    );
  }

  @Watch('balance', { immediate: true, deep: true })
  onBalanceChanged(newVal: any, oldVal: any) {
    this.cols.splice(0, this.cols.length);
    if (this.balance !== undefined) {
      for (let i = 0; i < this.balance.count; i++) {
        this.cols.push(i);
      }
    }
  }
}
